<label [ngClass]="{'label-disabled': !isEnabled}">{{ 'FormulationSearch.Label.Model' | translate }}</label>
<ng-select [(ngModel)]="value" [keyDownFn]="selectOnTab" [items]="models" bindLabel="name" name="model-select"
    [disabled]="!isEnabled" [ngClass]="{'ng-field-selected': isFilled}">

</ng-select>
